(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lintier-process-stepper"] && !Shopify.designMode) return;
  try {
    
  class LintierSteps extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.current = 1;
      this.style.setProperty('--active', 0);
      this.querySelectorAll('.lintier-steps__tick').forEach((t, i) => t.classList.toggle('is-active', i === 0));

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) return this.show(Number(tab.dataset.step));
        if (event.target.closest('[data-next]')) {
          const next = this.current >= this.panels.length ? 1 : this.current + 1;
          this.show(next, { scroll: true });
        }
      });

      /* arrow keys walk the numbers, as a tab list should */
      this.addEventListener('keydown', (event) => {
        if (!event.target.closest('[role="tab"]')) return;
        const delta = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
        if (!delta) return;
        event.preventDefault();
        const n = ((this.current - 1 + delta + this.panels.length) % this.panels.length) + 1;
        this.show(n, { focusTab: true });
      });

      this.#drag();
      this.#swipe();

      const fromHash = /^#step-(\d+)$/.exec(location.hash);
      if (fromHash) this.show(Number(fromHash[1]));
    }

    /* Drag the dial: the wheel follows the pointer, then settles on the
       nearest number. ~72px of travel per step on a phone, a little more
       on desktop where the arc is larger. A short move is a tap. */
    #drag() {
      const dial = this.querySelector('.lintier-steps__dial');
      if (!dial) return;
      const count = this.panels.length;
      let startX = 0, startActive = 0, moved = false, dragging = false, pointerId = null;
      const perStep = () => (window.innerWidth >= 990 ? 96 : 72);

      dial.addEventListener('pointerdown', (e) => {
        if (e.button !== undefined && e.button !== 0) return;
        dragging = true; moved = false;
        startX = e.clientX; startActive = this.current - 1;
        pointerId = e.pointerId;
      });
      dial.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        if (!moved && Math.abs(dx) < 6) return;
        if (!moved) { moved = true; this.classList.add('is-dragging'); try { dial.setPointerCapture(pointerId); } catch (_) {} }
        let a = startActive - dx / perStep();
        /* soft stop past either end */
        if (a < 0) a = a / 3;
        if (a > count - 1) a = count - 1 + (a - (count - 1)) / 3;
        this.style.setProperty('--active', a);
      });
      const end = (e) => {
        if (!dragging) return;
        dragging = false;
        if (!moved) return;
        const a = parseFloat(this.style.getPropertyValue('--active')) || 0;
        const n = Math.min(count, Math.max(1, Math.round(a) + 1));
        this.classList.remove('is-dragging');
        this.show(n);
        /* the tap that ends a drag must not also count as a click */
        this.suppressClickUntil = Date.now() + 300;
      };
      dial.addEventListener('pointerup', end);
      dial.addEventListener('pointercancel', end);
      this.addEventListener('click', (e) => {
        if (this.suppressClickUntil && Date.now() < this.suppressClickUntil && e.target.closest('[role="tab"]')) {
          e.stopImmediatePropagation(); e.preventDefault();
        }
      }, true);
    }

    /* A sideways swipe on the photograph steps through, phone-style. */
    #swipe() {
      const stage = this.querySelector('.lintier-steps__stage');
      if (!stage) return;
      let x0 = 0, y0 = 0;
      stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) < 48 || Math.abs(dy) > 40) return;
        const n = dx > 0 ? Math.min(this.panels.length, this.current + 1) : Math.max(1, this.current - 1);
        if (n !== this.current) this.show(n);
      }, { passive: true });
    }

    show(n, { focusTab = false, scroll = false } = {}) {
      if (!this.panels[n - 1]) return;
      this.current = n;
      this.tabs.forEach((tab, i) => {
        const on = i === n - 1;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== n - 1;
      });
      this.style.setProperty('--active', n - 1);
      this.querySelectorAll('.lintier-steps__tick').forEach((t, i) => { t.classList.toggle('is-active', i === n - 1); t.classList.toggle('is-passed', i < n - 1); });
      if (focusTab) this.tabs[n - 1].focus({ preventScroll: true });
      if (scroll) {
        const top = this.getBoundingClientRect().top + window.scrollY - 96;
        window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      history.replaceState(null, '', '#step-' + n);
    }
  }

  if (!customElements.get('lintier-steps')) customElements.define('lintier-steps', LintierSteps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
